// extracted by mini-css-extract-plugin
export var phone = "_25-0";
export var phoneDragging = "_25-1";